import React from "react";
import { useAppContext } from "../context/appContext";
import { Display, TextArea, FancySelect } from "./workspace";
import { FaTimes } from "react-icons/fa";
import { calcOptionTotal, calcCommissions } from "../utils/calcOptionTotal";
import { numberToMoney } from "../utils/money";
import ReviewItems from "./ReviewForm/ReviewItems";
import PriceSummary from "./ReviewForm/PriceSummary";

function JobReviewForm() {
  const {
    job,
    reviewJob,
    reviewAppointments,
    reviewOptions,
    reviewItems,
    reviewFees,
    reviewDiscounts,
    isLoading,
    handleChange,
    toggleReviewForm,
    // displayAlert,
    saveRecord,
    prices,
    lists,
    getJobLists,
    loadMainRecords,
  } = useAppContext();

  if (!reviewJob || !reviewOptions || !reviewItems || !reviewFees || !reviewDiscounts || !reviewAppointments) return null

  const fees = reviewFees.map((fee) => {
    return { ...fee, usePA: true };
  });
  const discounts = reviewDiscounts.map((disc) => {
    return { ...disc, usePA: true };
  });

  // const reviewOption = reviewJob.options_id
  //   ? reviewOptions.filter((option) => option.id === reviewJob.options_id)[0]
  //   : reviewOptions[0];

  const {
    // sales_tax: reviewOption?.sales_tax,
    grandTotal,
    jobsTotal,
    ttlPriceAdj,
    ttlCostTax,
    ttlCostMaterials,
    ttlCostLabor,
    profitTotal,
  } = calcOptionTotal({
    jobItems: reviewItems,
    fees,
    discounts,
    job: reviewJob,
    prices,
  });

  const commissions = prices?.commissions?.filter(
    (row) => row.price_sheets_id === reviewJob?.price_sheets_id
  )[0];

  const { salesRepNames, serviceRepNames, workCommission, saleCommission } = calcCommissions({
    salesReps: reviewJob?.sale_commission_ids,
    serviceReps: reviewJob?.service_commission_ids,
    profit: profitTotal,
    listServiceReps: lists.listServiceReps,
    jobType: reviewJob?.job_type_id,
    commissions,
  });

  const employeeOptions = lists.listServiceReps?.map((row) => {
    return { value: row.id, label: row.text };
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Save Job Items
    const jobItemPromises = reviewItems.map(async (jobItem) => {
      await saveRecord(`/job-items/update/${jobItem.id}`, { ...jobItem }, "job item");
    });
    await Promise.all(jobItemPromises);
    // Save core job info
    saveRecord(
      `/core-job/update/${reviewJob.id}`,
      { ...reviewJob, job_status_id: 8 },
      "Reviewd Job Info"
    );
    // Update All Jobs page
    getJobLists();
    // Update current job if it is the one being reviewed
    if (job?.id === reviewJob.id) {
      loadMainRecords(job.id);
    }
    // close form
    toggleReviewForm();
  };

  const handleEmployee = (selected, name) => {
    console.log("selected:", selected);
    const empIds = selected.map((item) => item.value);
    console.log("selected ids:", empIds);

    handleChange({
      baseObject: { ...reviewJob },
      name,
      value: empIds,
    });
  };

  const handleCancel = () => {
    toggleReviewForm();
  };

  const handleInput = (e) => {
    const name = e.target.name;
    const value = name === "reviewJob.office_job_notes" ? e.target.value : Number(e.target.value);
    handleChange({ baseObject: reviewJob, name, value });
  };

  return (
    <form className="form review-form">
      {/* Close Button */}
      <div className="modal-header flex-parent">
        <h4 className="one-half title">Testing Final Review for {reviewJob?.job_number}</h4>
        <div className="one-half">
          <button className="close-btn" type="button" onClick={handleCancel}>
            <FaTimes />
          </button>
        </div>
      </div>
      {/* Prompt Message */}
      <div className="form-center sub-item confirm-report">
        {/* Job Summary */}
        <div className="whole">
          <TextArea
            name="reviewJob.office_job_notes"
            labelText="Job Notes"
            value={reviewJob?.office_job_notes || ""}
            handleChange={(e) => handleInput(e)}
          />
        </div>
        {/* Cost Verification */}
        <div className="form-row whole">
          <h3>Verify Costs</h3>
          <ReviewItems jobsTotal={jobsTotal} ttlPriceAdj={ttlPriceAdj} />
        </div>
        {/* Commission */}
        <div className="form-row whole flex-parent">
          <h3>Commissions</h3>
          <div className="whole form-row">
            <table>
              <tbody>
                <tr>
                  <th style={{ width: 240 }}>Appointment Type</th>
                  <th style={{ width: 180 }}>Date</th>
                  <th>Service Reps</th>
                </tr>
                {reviewAppointments?.map((appt) => {
                  return (
                    <tr key={appt.id || 0}>
                      <td>
                        {appt.appt_types_id &&
                          lists.listApptTypes?.find((appointment) => {
                            return appointment.id === appt.appt_types_id;
                          })?.text}
                      </td>
                      <td>{appt.appt_date}</td>
                      <td>
                        {appt.employees_ids &&
                          appt.employees_ids.map((empId, i) => {
                            const match = lists.listAllServiceReps?.find((employee) => {
                              return employee.id === empId;
                            }).text;
                            const empName = i > 0 ? ", " + match : match;

                            return empName;
                          })}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="one-half">
            <FancySelect
              isMulti={true}
              name="reviewJob.sale_commission_ids"
              labelText="Sales Commission(s)"
              handleChange={(selected) => handleEmployee(selected, "reviewJob.sale_commission_ids")}
              value={reviewJob?.sale_commission_ids}
              options={employeeOptions}
            />
            {salesRepNames?.map((rep, i) => {
              return (
                <Display
                  name={rep}
                  value={numberToMoney(saleCommission / salesRepNames.length)}
                  key={i}
                />
              );
            })}
          </div>
          <div className="one-half">
            <FancySelect
              isMulti={true}
              name="reviewJob.service_commission_ids"
              labelText="Service Commission(s)"
              handleChange={(selected) =>
                handleEmployee(selected, "reviewJob.service_commission_ids")
              }
              value={reviewJob?.service_commission_ids}
              options={employeeOptions}
            />
            {serviceRepNames?.map((rep, i) => {
              return (
                <Display
                  name={rep}
                  value={numberToMoney(workCommission / serviceRepNames.length)}
                  key={i}
                />
              );
            })}
          </div>
        </div>
        {/* Price Summary */}
        <PriceSummary
          grandTotal={grandTotal}
          jobsTotal={jobsTotal}
          ttlPriceAdj={ttlPriceAdj}
          ttlCostTax={ttlCostTax}
          ttlCostMaterials={ttlCostMaterials}
          ttlCostLabor={ttlCostLabor}
          profitTotal={profitTotal}
          saleCommission={saleCommission}
          workCommission={workCommission}
        />
      </div>

      {/* Submit/Clear Buttons */}
      <div className="flex-parent whole btn-container">
        <div className="one-half">
          <button
            name="complete"
            className="btn btn-block"
            type="button"
            disabled={isLoading}
            onClick={(e) => handleSubmit(e)}
          >
            {isLoading ? "please wait..." : "Complete"}
          </button>
        </div>
        <div className="one-half">
          <button
            name="cancel"
            className="btn btn-block red"
            type="button"
            disabled={isLoading}
            onClick={handleCancel}
          >
            cancel
          </button>
        </div>
      </div>
    </form>
  );
}
export default JobReviewForm;
